import { TennisCourtReservationService } from "../../services/TennisCourtReservationService";
import { useApi } from "./useApi";
import { useConfiguration } from "./useConfiguration";

export const useTennisCourtReservationsApi = () => {
    const { executeApiOperation } = useApi();
    const { appConfig } = useConfiguration();

    const service = new TennisCourtReservationService(appConfig.apiBaseUrl);

    const findAll = async (propertyId, range) => {
        return executeApiOperation(() => service.findAll(propertyId, range));
    };

    const createReservation = async (propertyId, reservation) => {
        return executeApiOperation(() => service.create(propertyId, reservation));
    };

    return {
        findAll,
        createReservation,
    };
};
